export const HeaderAuth = {
    'Content-Type': 'application/json',
    'X-ILY-API-appKey': process.env.REACT_APP_HEADER_APPKEY as string
  }